// Anonymous device identification for the Question Helper pilot.
// No login, no PII — just a stable UUID stored in localStorage.

const KEY = 'geogon_qh_device_id';

export function getDeviceId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = (crypto.randomUUID && crypto.randomUUID()) ||
        ('xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
          const r = (Math.random() * 16) | 0;
          const v = c === 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }));
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch (e) {
    // localStorage unavailable — fall back to an ephemeral id
    return 'anon-session';
  }
}
